import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
//todo: lets fetch twice when render new week and has race condition and creates multis
root.render(
    <>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');
        </style>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
